import React from 'react';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import Slot from '../../../../types/BotBuilder/Slot';

interface ExistingVariableFormProps {
  selectedSlot: Slot | null;
  localIntentSlotName: string;
  slots: Slot[];
  onSlotChange: (slot: Slot | null) => void;
  onIntentSlotNameChange: (value: string) => void;
  onIntentSlotNameBlur: () => void;
  disabled?: boolean;
}

function ExistingVariableForm({
  selectedSlot,
  localIntentSlotName,
  slots,
  onSlotChange,
  onIntentSlotNameChange,
  onIntentSlotNameBlur,
  disabled = false
}: Readonly<ExistingVariableFormProps>): React.ReactElement {
  return (
    <>
      <CustomSelect
        label='Select global variable'
        value={selectedSlot?.slotName ?? ''}
        onValueChange={(value) => {
          const foundSlot = slots.find((s) => s.slotName === value) ?? null;
          onSlotChange(foundSlot);
        }}
        placeholder='Choose a global variable'
        options={slots.map((slot) => ({
          value: slot.slotName,
          label: slot.slotName
        }))}
        className='bg-white'
        disabled={disabled}
      />
      <CustomInput
        label='Variable name'
        value={localIntentSlotName}
        onChange={(e) => onIntentSlotNameChange(e.target.value)}
        onBlur={onIntentSlotNameBlur}
        className='bg-white'
        disabled={disabled}
      />
    </>
  );
}

export default ExistingVariableForm;
